<template lang="pug">
router-link.card.no-decoration.height-100(
  :to="{ name: 'app.cadastro', params: { id: cadastro.id } }"
)
  .card-body
    .float-right
      i.fa.fa-chevron-right.text-primary
    .columns
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.tipo' | tModel",
          :text="`enums.db.enum_cadastro_tipo.${cadastro.tipo}` | translate"
        )
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.situacao' | tModel",
          :text="cadastro.situacao.descricao"
        )
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.numero' | tModel",
          :text="cadastro.numero"
        )
      .column.col-4.col-sm-6
        text-output(:label="'cadastro.zona' | tModel", :text="cadastro.zona")
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.quadra' | tModel",
          :text="cadastro.quadra"
        )
      .column.col-4.col-sm-6
        text-output(:label="'cadastro.lote' | tModel", :text="cadastro.lote")
      .column.col-12.text-small.mt-1 {{ cadastro.endereco_formatado }}
</template>

<script>
export default {
  props: { cadastro: { type: Object, required: true } },
};
</script>
